import { render, staticRenderFns } from "./Segnalazione.vue?vue&type=template&id=0a49d540&scoped=true"
import script from "./Segnalazione.vue?vue&type=script&lang=js"
export * from "./Segnalazione.vue?vue&type=script&lang=js"
import style0 from "./Segnalazione.vue?vue&type=style&index=0&id=0a49d540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49d540",
  null
  
)

export default component.exports